import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {OfferGoal} from '../../models/offer-goal';

@Injectable({
  providedIn: 'root'
})
export class OfferGoalService extends AbstractModelService<OfferGoal> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/offer-goal', OfferGoal);
  }
}
